module.exports = __webpack_public_path__ + "static/media/6-2.1f6a1f42.mp3";